import client from 'client';

import { SERVER_URL } from 'constants/index';

const getUrl = (transferId) => {
    return `${SERVER_URL}/api/v1/transfers/${transferId}/paidfeatures/verifypayment`;
}

const vefifyPayment = async (transferId, body = {}) => {
    const url = getUrl(transferId);

    return await client.post(
        url,
        JSON.stringify(body),
        {
          headers: { 'Content-Type': 'application/json' },
        }
    )
}

export default vefifyPayment;